export enum HttpMethod {
  GET,
  POST,
  PUT,
  DELETE,
  PATCH,
}
export enum Result {
  SUCCESS,
  FAILURE
}

export enum NotificationRouting {
  OverView,
  Employees,
  Meeting,
  Credit,
  Report,
  Contact,
  Company
}

export enum FeedbackType {
  FLEXIDESK = 'a',
  PRIIVATESUITE = 'b'
}

export enum Roles {
  CLAdmin = 'CLAdmin',
  TAdmin = 'TAdmin',
  CLCoAdmin = 'CLCoAdmin',
  TCoAdmin = 'TCoAdmin',
  GeneralUser = 'GeneralUser',
  TenantUser = 'TenantUser',
  ParkAdmin = 'ParkAdmin',
  ParkCoAdmin = 'ParkCoAdmin',
  ERT = 'ERT'
}

export enum DisplayType {
  AdminCoadmin = 1,
  ERT,
  Active,
  Inactive
}
